import axios from 'axios';
// import auth from '../store/modules/auth';
import firebase from 'firebase/app';

export default () => {
  axios.interceptors.request.use(
    async (config) => {
      const user = await firebase.auth().currentUser;
      // console.log('user', await user.getIdToken());
      // console.log('current user', auth.state.currentUser.getIdToken());
      // const test = auth.state.currentUser.getIdToken();
      // debugger;

      // const currentUser = auth.getters.get_current_user;

      if (user) {
        const token = await user.getIdToken();
        // console.log('token', token);
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );
};
